import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { BObjectModel } from '../models';
import { CoreService } from '../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {

  public model: BObjectModel;
  public insertDocIsActive: boolean = true;
  private _idDonneePere: string = this.indParam.AppParams.LoggedUser.Ident;
  @Input('idDonneePere')
  set idDonneePere(value: string) {
    this._idDonneePere = value ? value : this.indParam.AppParams.LoggedUser.Ident;
  }

  private _idBo: string = '';
  @Input('idBo')
  set idBo(value: string) {
    this._idBo = value;
  }

  private _relation: string = '';
  @Input('relation')
  set relation(value: string) {
    this._relation = value;
  }

  public customgrid: string = '';
  @Input('customgridName')
  set customgridName(value: string) {
    this.customgrid = value;
  }

  constructor(
    private indParam: CoreService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.model = new BObjectModel();
    this.model.Mode = 'CREATE';
    this.model.IdRelation = this._relation;
    this.model.IdDonneePere = this._idDonneePere;
    this.model.IdDonneeFils = '0';
    this.model.IdentBO = this._idBo;
  }

  public updateCustomgrid(needUpdate: boolean): void {
    if (needUpdate) {
      const tampon: string = this.customgrid;
      this.customgrid = '';
      this.insertDocIsActive = false;
      this.cd.detectChanges();
      this.customgrid = tampon;
      const closeModal: HTMLElement | null = document.getElementById('closeModal');
      if (closeModal) {
        closeModal.click();
      }
      this.insertDocIsActive = true;
    }
  }
}
